import React, { FC, ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/Term/Term.module.scss';

const cn = classNames.bind(styles);

type Term = {
  name: string;
  url: string;
  description?: string;
  isSearch?: boolean;
}

const Term: FC<Term> = ({ name, url, description, isSearch }: Term): ReactElement => {
  return (
    <li className={cn('term')}>
      <Link
        className={cn('term__link')}
        href={`freight-dictionary/${url}` as Route}
      >
        {name}
      </Link>
      <p className={cn('term__ellipsis')}>{description}</p>
    </li>
  );
};

export { Term };